import type { CommitmentFrequencyEnum } from '@sola/schema/dotcom/cart/commitments.ts';
import type { GiftTypeEnum } from '@sola/schema/dotcom/cart/gift.ts';
import type {
  DefaultPaymentOptionSet,
  PaymentOptionSet,
} from '@sola/schema/dotcom/proxy-api/giftLimits.ts';
import type { GraphQLCommitment } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import type { IconNames } from '@sola/schema/lib/icons/icon-names.ts';
import type { BadgeColors } from '@sola/schema/lib/schema.ts';

export enum ButtonAction {
  AddGift = 'addGift',
  GiveAnother = 'giveAnother',
  SetupRecurring = 'setupRecurring',
  Edit = 'edit',
}

export enum GiftTooltip {
  RecurringGivingSetup = 'recurringGivingSetup',
  BirthdayGiftMaxed = 'birthdayGiftMaxed',
  BirthdayGiftGiven = 'birthdayGiftGiven',
  ChildGiftMaxed = 'childGiftMaxed',
  FamilyGiftAmountMaxed = 'familyGiftAmountMaxed',
  FamilyGiftQuantityMaxed = 'familyGiftQuantityMaxed',
  CenterGiftAmountMaxed = 'centerGiftAmountMaxed',
  CenterGiftLimitMaxed = 'centerGiftLimitMaxed',
  GiftBelowLimit = 'giftBelowLimit',
  FamilyGiftBelowLimit = 'familyGiftBelowLimit',
  ChildGiftAndBirthdayGiven = 'childGiftAndBirthdayGiven',
  BirthdayGiftNotRecurring = 'birthdayGiftNotRecurring',
  BirthdayGiftIneligible = 'birthdayGiftIneligible',
  SameCenterNotification = 'sameCenterNotification',
  FinalGiftAlreadyGiven = 'finalGiftAlreadyGiven',
}

export enum ProgressLabelKey {
  //GiftsSingular = 'giftCommitmentCard.progressLabel_one',
  GiftsPlural = 'giftCommitmentCard.progressLabel',
  ChildGiftsGiven = 'giftCommitmentCard.progressLabelChildGiftsGiven',
  Family = 'giftCommitmentCard.progressLabelFamily',
  Final = 'giftCommitmentCard.progressLabelFinal',
  CartConflict = 'giftCommitmentCard.progressLabelCartConflict',
}

export enum BadgeLabel {
  RecurringGiving = 'giftCommitmentCard.badgeText.recurringGiving',
  SameCenter = 'giftCommitmentCard.badgeText.sameCenter',
}

export interface GiftOption {
  canGive: boolean; // has the user crossed any giving limit cap
  buttonAction: ButtonAction | null;
  progressLabel: { given: number; max: number; labelKey: string } | null;
  tooltip: { key: GiftTooltip; count?: number } | null;
  badge: { label: BadgeLabel; color: BadgeColors; icon: IconNames } | null;
  cartItem: {
    cartId: string;
    amount: number | null;
    frequency?: CommitmentFrequencyEnum;
  } | null; // if the gift option is currently in the cart, include the cart item id, amount, and frequency for reference
  paymentOptions: PaymentOptionSet; // API data
  paymentOptionsMinMax: DefaultPaymentOptionSet; // API data
  centerId?: string;
}

export interface ChildGiftOption {
  commitment: GraphQLCommitment;
  giftOption: GiftOption;
}

export type ChildGiftOptionGroups = Record<GiftTypeEnum, ChildGiftOption[]>;
